import { Button, Form, Input, Modal, Radio, Row, notification } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactQuill from 'react-quill';
import { validateQuillContent } from '../data';
import { insertNotificationApi } from '../api/NotificationApis';

type DrawerStatusProps = {
  open: boolean;
  title: string;
  status: string;
};

type Props = {
  data: any;
  onRefreshData: Function;
};

//LOGIC xử lý: data truyền vào là {} --> thêm mới, {id,...} là cập nhật
const InsertUpdateNotification = ({ data, onRefreshData }: Props) => {
  const [modalStatus, setDrawerStatus] = React.useState<DrawerStatusProps>({
    status: '',
    open: false,
    title: '',
  });

  const [isProcessing, setIsProcessing] = useState(false);
  const loggedInUser = useSelector((state) => state.authReducer.loggedInUser);

  const [formUpdate] = useForm();
  const actionStatus = data?.id ? 'edit' : 'add';
const initialValues = {
    title: '',
    content: '',
    receiver: '',
}
  //Drawer sẽ được bật lên khi data thay đổi
  useEffect(() => {
    //LOGIC xử lý: data truyền vào là {} --> thêm mới, {id,...} là cập nhật
    if (data) {
      if (data?.id) {
        handleVisibleDrawer('edit', data);
      } else {
        handleVisibleDrawer('add', data);
      }
    }
  }, [data]);

  const handleVisibleDrawer = (type: 'add' | 'edit' | 'close' | 'save_success', record: any = null) => {
    if (type === 'add') {
      setDrawerStatus({
        title: 'TẠO MỚI',
        open: true,
        status: type,
      });
      formUpdate.resetFields();
    } else if (type === 'edit') {
      formUpdate.setFieldsValue({
        title: record.title,
        content: record.content,
        receiver: record.receiver,
      });
      setDrawerStatus({
        title: 'CẬP NHẬT',
        open: true,
        status: type,
      });
    } else if (type === 'close') {
      setDrawerStatus({
        title: '',
        open: false,
        status: type,
      });
    } else if (type === 'save_success') {
      onRefreshData();
      setDrawerStatus({
        title: '',
        open: false,
        status: type,
      });
    }
  };

  const onInsertUpdate = async (formValues: any) => {
    if (!isProcessing) {
      try {
        await setIsProcessing(true);
        const { title, content, receiver } = formValues;
        const res = await insertNotificationApi({
          Avatar: loggedInUser.avatarUrl ?? '',
          UserId: loggedInUser.id,
          Title: title,
          Content: content,
          Type: receiver === 'ALL' ? 'ALL' : 'ROLE',
          TypeData: receiver,
          Setting:''
        })
          .then((res) => {
            notification.success({
              message: 'Thành công',
              description: 'Lưu dữ liệu thành công!',
            });
            // status : 0 là error, 1 là thành công, 2 là warning
            handleVisibleDrawer('save_success');
          })
          .catch((err) => {
            notification.error({
              message: 'Thất bại',
              description: 'Lưu dữ liệu thất bại!',
            });
          });
        setIsProcessing(false);
      } catch (error) {
        notification.error({
          message: 'Thất bại',
          description: 'Lưu dữ liệu thất bại!',
        });
        setIsProcessing(false);
      }
    }
  };

  return (
    <div>
      <Modal
        open={modalStatus?.open}
        width='90%'
        title={modalStatus?.title}
        onCancel={() => handleVisibleDrawer('close')}
        footer={
          <Row justify='end' gutter={12}>
            <Button onClick={() => handleVisibleDrawer('close')}>Đóng</Button>
            <Button type='primary' loading={isProcessing} onClick={() => formUpdate.submit()}>
              Tạo thông báo
            </Button>
          </Row>
        }
        destroyOnClose
      >
        <Form form={formUpdate} initialValues={initialValues} onFinish={onInsertUpdate} layout='vertical'>
          <Form.Item label={'Tiêu đề thông báo'} name='title' rules={[{ message: 'Chưa nhập tiêu đề', required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item
            label='Nội dung thông báo'
            name='content'
            required
            rules={[
              {
                validator: validateQuillContent,
              },
            ]}
          >
            <ReactQuill
              theme='snow'
              modules={{ toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }], ['link'], ['clean']] }}
              formats={['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image']}
            />
          </Form.Item>
          <Form.Item label='Người nhận thông báo' name='receiver' rules={[{ message: 'Chưa nhập người nhận thông báo', required: true }]}>
            <Radio.Group>
              <Radio value='STUDENT'>Học sinh</Radio>
              <Radio value='TEACHER'>Giáo viên</Radio>
              <Radio value='ALL'>Tất cả</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default InsertUpdateNotification;
